// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "invoices".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { invoiceStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "invoices" table (1:1 with a DB row, on the wire). */
export const invoicesAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    stripeInvoiceId: z.string(),
    stripeCustomerId: z.string(),
    subscriptionId: z.string().nullable(),
    status: z.enum(invoiceStatusValues),
    amountDue: z.number(),
    amountPaid: z.number(),
    currency: z.string(),
    hostedInvoiceUrl: z.string().nullable(),
    invoicePdf: z.string().nullable(),
    periodStart: z.string().datetime().nullable(),
    periodEnd: z.string().datetime().nullable(),
    dueDate: z.string().datetime().nullable(),
    paidAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=invoices.js.map